import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MaterialModule} from "../../material/material.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateNewPropertyComponent } from './create-new-property/create-new-property.component';
import { PropertyInfoStepComponent } from './property-info-step/property-info-step.component';
import { PropertiesListComponent } from './properties-list/properties-list.component';
import { PropertiesDetailComponent } from './properties-detail/properties-detail.component';
import { PropertiesDetailInfoComponent } from './properties-detail-info/properties-detail-info.component';
import { PropertiesDetailOwnersComponent } from './properties-detail-owners/properties-detail-owners.component';
import { PropertiesDetailReportingComponent } from './properties-detail-reporting/properties-detail-reporting.component';
import { PropertiesDetailLicenseComponent } from './properties-detail-license/properties-detail-license.component';
import { PropertiesSingleOwnerComponent } from './properties-single-owner/properties-single-owner.component';
import { DeactivatePropertyComponent } from './deactivate-property/deactivate-property.component';
import { PropertyStatusComponent } from './property-status/property-status.component';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { ReportingFormComponent } from './reporting-form/reporting-form.component';
import { LicenseFormComponent } from './license-form/license-form.component';
import { OwnerFormComponent } from './owner-form/owner-form.component';
import { ConfirmationCancelPropertyComponent } from './confirmation-cancel-property/confirmation-cancel-property.component';
import { PropertyFooterOptionsComponent } from './property-footer-options/property-footer-options.component';
import { RegisterStepperModule } from '../register/register-stepper.module';
import { TaxCertificateNumberDirective } from '../../directives/tax-number-input.directive';



@NgModule({
  declarations: [
    CreateNewPropertyComponent,
    PropertyInfoStepComponent,
    PropertiesListComponent,
    PropertiesDetailComponent,
    PropertiesDetailInfoComponent,
    PropertiesDetailOwnersComponent,
    PropertiesDetailReportingComponent,
    PropertiesDetailLicenseComponent,
    PropertiesSingleOwnerComponent,
    DeactivatePropertyComponent,
    PropertyStatusComponent,
    ReportingFormComponent,
    LicenseFormComponent,
    OwnerFormComponent,
    ConfirmationCancelPropertyComponent,
    PropertyFooterOptionsComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    RouterLinkActive,
    RegisterStepperModule,
    TaxCertificateNumberDirective,
  ],
  exports: [RouterModule],
})
export class PropertyModule {}
